module.exports = __webpack_public_path__ + "img/vip-banner-regular.daf51e73.png";